import React from "react";
import { Alert, AlertTitle, Box } from '@mui/material';
import { useTranslation } from "react-i18next";
import { APIError } from "system/APIRequest";

export interface APIErrorAlertProps {
  fetchError: APIError;
  children?: React.ReactNode;
}

export function APIErrorAlert(props: APIErrorAlertProps): JSX.Element {
  const { i18n } = useTranslation();

  const fetchError = props.fetchError;

  return (
    <Alert severity="error" style={{ margin: "1rem" }}>
      <AlertTitle>{i18n.t("admin.resources.load-error-header")}</AlertTitle>
      {props.children}<br/>
      {fetchError?.message || fetchError?.server_message} ({fetchError?.code})
      {fetchError?.body?.error &&
        <Box sx={{mt:1}}>
          {fetchError?.body?.error}
        </Box>
      }
    </Alert>
  );
}